var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileItemOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "rotate(90 12 12)",
    fill: "#1ea149"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3886 15.8411L16.8442 11.2904C16.9441 11.1848 17 11.0436 17 10.8967C17 10.7499 16.9441 10.6088 16.8442 10.5032L16.5129 10.1648C16.4103 10.0611 16.2718 10.0029 16.1275 10.0029C15.9831 10.0029 15.8446 10.0611 15.7421 10.1648L12.0032 13.9835L8.25759 10.1648C8.20726 10.1126 8.14725 10.0711 8.08109 10.0428C8.01493 10.0145 7.94393 10 7.8722 10C7.80048 10 7.72945 10.0145 7.66329 10.0428C7.59713 10.0711 7.53714 10.1126 7.48682 10.1648L7.15553 10.4962C7.05507 10.6015 6.99921 10.7429 7.00002 10.8898C6.99888 11.0389 7.05467 11.1826 7.15553 11.2904L11.6111 15.8411C11.7166 15.9441 11.8573 16.0011 12.0032 15.9999C12.0746 16.0011 12.1455 15.9877 12.2117 15.9604C12.2778 15.9331 12.338 15.8925 12.3886 15.8411Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileItemOpened);
export default __webpack_public_path__ + "static/media/mobileItemOpened.64c0ba648881f4abf38924beb5fe74d8.svg";
export { ForwardRef as ReactComponent };